
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotel/[id]/[name]",
      function () {
        return require("private-next-pages/hotel/[id]/[name].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotel/[id]/[name]"])
      });
    }
  